import {ChangeDetectionStrategy, Component, model} from '@angular/core';
import {Tenors} from '../../../domain/tenors';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-tenors-bar',
  imports: [IonicModule, TranslateModule],
  templateUrl: './tenors-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./tenors-bar.component.scss']
})
export class TenorsBarComponent {
  readonly activeTenor = model<Tenors>(Tenors.ONE_DAY);

  protected readonly tenorList = Object.values(Tenors);

  protected changeTenor(tenor: Tenors): void {
    this.activeTenor.set(tenor);
  }
}
